import { z } from "@/zod";

export const readContractorPlannedHours = z
  .object({
    id: z.string(),
    period: z.string(),
    planned_hours: z.number(),
  })
  .readonly();

export const contractorPanelPlannedHoursStatus = z
  .object({
    should_show_planned_hours: z.boolean(),
    approved_at: z.string().optional(),
    // Zwracane przy niezmienionym budżecie, gdy włączone ustawienie
    // "Budżet wykonawcy – stała widoczność" (ASMMNT-102).
    period: z.string().optional(),
    planned_hours: z.string().optional(),
  })
  .readonly();

export const contractorPanelPlannedHoursAccept = z
  .object({
    period: z.string(),
    planned_hours: z.string(),
  })
  .readonly();
